import { Firestore, Firebase } from "../lib/firebase";

const secondQuery = text => {
    const lastLetter = String.fromCharCode(text.charCodeAt(text.length - 1) + 1);
    const query = text.slice(0, -1) + lastLetter;
    return query;
}

const USER_TABLE_NAME = "users";

/**
 * Finds a user with the exact match of the value
 * of a field with your search text.
 *
 * * **Example:**
 * field can be "email" and so your value
 * should be the user email, like user@mail.com.
 * ---
 * @param {*} field any field in the users table
 * @param {*} search your search query
 */
export async function getUserByField(field, search) {
    const res = await Firestore.collection(USER_TABLE_NAME)
        .where(field, "==", search)
        .get();

    const users = res.docs.map((user) => Object({ id: user.id, ...user.data() }));
    return users[0];
}

export const filterUsersByField = async (field, search, country) => {
    const secondary = secondQuery(search);
    try {
        const res = await Firestore.collection(USER_TABLE_NAME)
            .where(field, ">=", search)
            .where(field, "<=", secondary)
            .where("country", "==", country)
            .get()
        const users = [];
        for (const doc of res.docs) {
            const user = doc.data();
            user.id = doc.id;
            users.push(user);
        }
        return users;
    } catch (error) {
        throw new Error(error.message)
    }
}

export const getUsersByThreeFields = async (queries) => {

    try {
        const res = await Firestore.collection(USER_TABLE_NAME)
            .where(queries[0].field, "==", queries[0].search)
            .where(queries[1].field, "==", queries[1].search)
            .where(queries[2].field, "==", queries[2].search)
            .get()
        const users = [];
        for (const doc of res.docs) {
            const user = doc.data();
            user.id = doc.id;
            users.push(user);
        }
        return users;
    } catch (error) {
        throw new Error(error.message)
    }
}
export const updateUserFields = async ({ customerId, payload }) => {
    await Firestore.collection(`users`).doc(customerId)
        .set(payload, { merge: true });
}

export function getUserById(userId) {
    return Firestore.collection(USER_TABLE_NAME)
        .doc(userId)
        .get()
        .then((result) => {
            const user = result.data();
            user.id = result.id;
            return user;
        })
        .catch((error) => error);
}
export function getUsersByIds(users) {
    return Firestore.collection(USER_TABLE_NAME)
        .where(Firebase.firestore.FieldPath.documentId(), "in", users)
        .get()
        .then((results) => {
            const users = [];
            for (const doc of results.docs) {
                const user = doc.data();
                user.id = doc.id;
                users.push(user);
            }
            return users;
        })
        .catch((error) => {
            throw new Error(error);
        });
}

/**
 * /users/<user_id>/boxes/<box_id>/items/<item_id>
 */
export const getUserBoxItemByProductBarcode = async (userId, boxID, productBarcode) => {
    const codeCollection = Firestore.collection(USER_TABLE_NAME)
        .doc(userId)
        .collection("boxes")
        .doc(boxID)
        .collection("items")
        .where("barcode", "==", productBarcode)

    try {
        const results = await codeCollection.get();
        const items = [];
        for (const doc of results.docs) {
            const item = doc.data();
            item.id = doc.id;
            items.push(item);
        }
        return items.length ? items[0] : null;
    }
    catch (error) {
        return error;
    }
}

/**
 *
 * @param userId
 * @param boxId
 * @param itemId
 * @param payload { product description, name and image urls }
 * @param callback
 */
export const setUserBoxItem = async (userId, boxId, itemId, payload) => {
    const codeCollection = Firestore.collection(USER_TABLE_NAME)
        .doc(userId)
        .collection("boxes")
        .doc(boxId)
        .collection("items")
        .doc(itemId)

    try {

        await codeCollection.set(payload, { merge: true })
    }
    catch (error) {
        return error;
    }
}
export const updateUserBoxItemByBarcode = async ({ userId, boxId, barcode, payload }) => {
    const codeCollection = Firestore.collection('users')
        .doc(userId)
        .collection('boxes')
        .doc(boxId)
        .collection('items')
        .where('barcode', '==', barcode)

    try {
        // const users = res.docs.map((user) => Object({ id: user.id, ...user.data() }));
        const res = await codeCollection.get();
        const items = res.docs.map((item) => Object({ id: item.id, ...item.data() }));

        await Firestore.collection(USER_TABLE_NAME)
            .doc(userId)
            .collection('boxes')
            .doc(boxId)
            .collection('items')
            .doc(items[0].id).update(payload);

    }
    catch (error) {
        return error;
    }
}

export const updateUserBoxItemByID = async (userId, boxId, itemId, payload) => {
    const codeCollection = Firestore.collection(USER_TABLE_NAME)
        .doc(userId)
        .collection('boxes')
        .doc(boxId)
        .collection('items')
        .doc(itemId)

    try {
        await codeCollection.update(payload);
    }
    catch (error) {
        return error;
    }
}
/**
 *
 * @param userId
 * @param targetCollection
 * @param documentID
 * @param callback
 */
export function getUserFeedbackCollections(
    userId,
    targetCollection,
    documentID
) {
    return Firestore.collection(USER_TABLE_NAME)
        .doc(userId)
        .collection(targetCollection)
        .where("documentID", "==", documentID)
        .get()
        .then((results) => {
            const items = [];
            for (const doc of results.docs) {
                const item = doc.data();
                item.id = doc.id;
                item.collection_name = targetCollection;
                items.push(item);
            }

            return items.length ? items[0] : null;
        })
        .catch((error) => error);
}

/**
 *
 * @param userId
 * @param boxId
 * @param itemId
 * @param payload { product description, name and image urls }
 * @param callback
 */
export function setUserFeedbackCollections(
    userId,
    targetCollection,
    documentID,
    payload
) {
    return Firestore.collection(USER_TABLE_NAME)
        .doc(userId)
        .collection(targetCollection)
        .doc(documentID)
        .set(payload, { merge: true })
        .catch((error) => error);
}

export function addStripeSubscription(userId, payload) {
    return Firestore.collection(USER_TABLE_NAME).doc(userId)
        .update(payload)
        .catch((error) => {
            throw new Error(error);
        });
}

export function getUserBoxes(userId) {
    return Firestore.collection(USER_TABLE_NAME)
        .doc(userId)
        .collection("boxes")
        .orderBy("createdAt", "desc")
        .get()
        .then((results) => {
            const boxes = [];
            for (const doc of results.docs) {
                const box = doc.data();
                box.id = doc.id;
                boxes.push(box);
            }

            return boxes;
        })
        .catch((error) => error);
}

export const getUserBoxByBoxId = async (userId, boxId) => {
    const codeCollection = Firestore.collection(USER_TABLE_NAME)
        .doc(userId)
        .collection("boxes")
        .doc(boxId)

    try {
        const result = await codeCollection.get();
        return result.data();

    } catch (error) {
        throw new Error(error.message);
    }
}

export function deleteUserBox(userId, boxId) {
    return Firestore.collection(USER_TABLE_NAME)
        .doc(userId)
        .collection("boxes")
        .doc(boxId)
        .delete()
        .catch((error) => error);
}

export const getUserBoxItems = async (userId, boxId) => {
    return await Firestore.collection(USER_TABLE_NAME)
        .doc(userId)
        .collection("boxes")
        .doc(boxId)
        .collection("items")
        .get()
        .then((results) => {
            const items = [];
            for (const doc of results.docs) {
                const item = doc.data();
                item.id = doc.id;
                items.push(item);
            }

            return items;
        })
        .catch((error) => error);
}

export function getUserBoxItemByFieldValue(userId, boxId, field, value) {
    return Firestore.collection(USER_TABLE_NAME)
        .doc(userId)
        .collection("boxes")
        .doc(boxId)
        .collection("items")
        .where(field, "==", value)
        .get()
        .then((results) => {
            const items = [];
            for (const doc of results.docs) {
                const item = doc.data();
                item.id = doc.id;
                items.push(item);
            }

            return items.length ? items[0] : null;
        })
        .catch((error) => error);
}

export function createUserBoxItem(userId, boxId, payload) {
    return Firestore.collection(USER_TABLE_NAME)
        .doc(userId)
        .collection("boxes")
        .doc(boxId)
        .collection("items")
        .doc()
        .set(payload)
        .then((result) => result)
        .catch((error) => error);
}

export function deleteUserBoxItems(userId, boxId, itemId) {
    return Firestore.collection(USER_TABLE_NAME)
        .doc(userId)
        .collection("boxes")
        .doc(boxId)
        .collection("items")
        .doc(itemId)
        .delete()
        .catch((error) => error);
}

export function getUserCollection(userId, collectionName) {
    return Firestore.collection(USER_TABLE_NAME)
        .doc(userId)
        .collection(collectionName)
        .get()
        .then((results) => {
            const data = [];
            for (const doc of results.docs) {
                const d = doc.data();
                d.id = doc.id;
                data.push(d);
            }

            return data;
        })
        .catch((error) => error);
}

// Comments
export function getUserComments(userId) {
    return Firestore.collection(USER_TABLE_NAME)
        .doc(userId)
        .collection('comments')
        .orderBy('timestamp', 'desc')
        .get()
        .then((results) => {
            const data = [];
            for (const doc of results.docs) {
                const d = doc.data();
                d.id = doc.id;
                data.push(d);
            }

            return data;
        })
        .catch((error) => error);
}

export function addComment(payload, userId) {
    return Firestore.collection('users').doc(userId)
        .collection('comments')
        .doc()
        .set(payload, { merge: true })
        .catch((error) => {
            return error;
        })
}

export function deleteComment(userId, commentId) {
    return Firestore.collection("users").doc(userId)
        .collection("comments").doc(commentId)
        .delete()
        .catch((error) => {
            console.error("Error deleting comment: ", error);
        });
}
